webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Playground_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Playground_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Playground_vue__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [
        {
            path: '/',
            name: 'Playground',
            component: __WEBPACK_IMPORTED_MODULE_2__pages_Playground_vue___default.a
        }
    ]
}));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(22),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spectre_css__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spectre_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_spectre_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vm_ts__ = __webpack_require__(12);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1__App_vm_ts__["a" /* default */]);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resizer_vm__ = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Resizer_vm__["a" /* default */]);


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Playground_vm__ = __webpack_require__(17);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Playground_vm__["a" /* default */]);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var App = (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return App;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
App = __decorate([
    __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({})
], App);
/* harmony default export */ __webpack_exports__["a"] = (App);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resizer_state__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draggable__ = __webpack_require__(14);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var TYPE_PREFIX = 'rr-resizable-';
var HANDLE_SELECTOR = '.rr-resizable-handle';
var Resizer = (function (_super) {
    __extends(Resizer, _super);
    function Resizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Resizer.prototype.data = function () {
        var state = new __WEBPACK_IMPORTED_MODULE_2__resizer_state__["a" /* default */]({
            left: this.left,
            top: this.top,
            width: this.width,
            height: this.height
        }, this.rotation);
        return {
            state: state
        };
    };
    Resizer.prototype.created = function () {
        var _this = this;
        this.$watch('rotatable', function (val) {
            var _this = this;
            if (val) {
                this.$nextTick(function () { return _this.bindRotateEvent(); });
            }
        });
        this.$watch('handles', function () {
            var _this = this;
            this.$nextTick(function () { return _this.bindResizeEvent(); });
        });
        var STATE_PROPS = ['width', 'height', 'rotation', 'left', 'top'];
        STATE_PROPS.forEach(function (prop) {
            _this.$watch(prop, function (val) {
                this.state[prop] = val;
            });
        });
    };
    Object.defineProperty(Resizer.prototype, "rectHandles", {
        get: function () {
            var handles = this.handles || 'n,e,s,w,nw,ne,se,sw';
            return handles.split(',').map(function (handle) { return handle.trim(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizer.prototype, "value", {
        get: function () {
            var state = this.state;
            return {
                left: state.left,
                top: state.top,
                width: state.width,
                height: state.height,
                rotation: state.rotation
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizer.prototype.hasHandle = function (ord) {
        return this.rectHandles.indexOf(ord) !== -1;
    };
    Resizer.prototype.mounted = function () {
        this.bindResizeEvent();
        this.bindDragEvent();
        this.bindRotateEvent();
    };
    Resizer.prototype.bindRotateEvent = function () {
        var handle = this.$refs.rotateHandle;
        if (!handle)
            return;
        var self = this;
        var el = self.$el;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__draggable__["a" /* default */])(handle, {
            start: function () {
                if (self.disabled)
                    return false;
            },
            drag: function (event) {
                var bounds = el.getBoundingClientRect();
                var center = {
                    left: bounds.left + bounds.width / 2,
                    top: bounds.top + bounds.height / 2
                };
                self.state.rotation = (Math.atan2(event.clientY - center.top, event.clientX - center.left) * 180 / Math.PI + 90) % 360;
                self.emitInputEvent(self.value);
            },
            end: function () {
                self.emitChangeEvent();
            }
        });
    };
    Resizer.prototype.bindDragEvent = function () {
        var self = this;
        var dom = this.$el;
        var dragState = {};
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__draggable__["a" /* default */])(dom, {
            start: function (event) {
                if (!self.draggable || self.disabled)
                    return false;
                dragState.startX = event.clientX;
                dragState.startY = event.clientY;
            },
            drag: function (event) {
                var deltaX = event.clientX - dragState.startX;
                var deltaY = event.clientY - dragState.startY;
                var rect = self.state.translate(deltaX, deltaY);
                rect.rotation = self.state.rotation;
                self.emitInputEvent(rect);
                dragState.rect = rect;
                dom.style.left = rect.left + 'px';
                dom.style.top = rect.top + 'px';
                dom.style.width = rect.width + 'px';
                dom.style.height = rect.height + 'px';
            },
            end: function () {
                if (dragState.rect) {
                    self.state.reset(dragState.rect);
                    self.emitChangeEvent();
                }
            }
        });
    };
    Resizer.prototype.emitInputEvent = function (rect) {
        this.$emit('input', rect);
    };
    Resizer.prototype.emitChangeEvent = function () {
        var rect = this.value;
        this.$emit('change', rect);
    };
    Resizer.prototype.bindResizeEvent = function () {
        var self = this;
        var dom = this.$el;
        var aspectRatio = self.aspectRatio;
        if (typeof aspectRatio !== 'number') {
            aspectRatio = undefined;
        }
        var handles = dom.querySelectorAll(HANDLE_SELECTOR);
        for (var i = 0, j = handles.length; i < j; i++) {
            this.makeHandleResizable(handles[i]);
        }
    };
    Resizer.prototype.makeHandleResizable = function (handle) {
        var self = this;
        var el = this.$el;
        var type = handle.className.split(' ')[1].replace(TYPE_PREFIX, '');
        var resizeState = {};
        var startPoint;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__draggable__["a" /* default */])(handle, {
            start: function (event) {
                if (self.disabled)
                    return false;
                resizeState.startX = event.clientX;
                resizeState.startY = event.clientY;
                startPoint = self.state.getPoint(type);
            },
            drag: function (event) {
                var deltaX = event.clientX - resizeState.startX;
                var deltaY = event.clientY - resizeState.startY;
                var rect = self.state.dragPoint(type, deltaX, deltaY, startPoint);
                resizeState.rect = rect;
                rect.rotation = self.state.rotation;
                self.emitInputEvent(rect);
                if (rect.left !== undefined) {
                    el.style.left = rect.left + 'px';
                    el.style.top = rect.top + 'px';
                }
                if (rect.width !== undefined) {
                    el.style.width = rect.width + 'px';
                    el.style.height = rect.height + 'px';
                }
            },
            end: function () {
                if (resizeState.rect) {
                    self.state.reset(resizeState.rect);
                    self.emitChangeEvent();
                }
            }
        });
    };
    return Resizer;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
Resizer = __decorate([
    __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
        name: 'rotatable-resizer',
        props: {
            disabled: {
                type: Boolean
            },
            active: {
                type: Boolean,
                default: true
            },
            rotatable: {
                type: Boolean
            },
            draggable: {
                type: Boolean
            },
            handles: {
                type: String
            },
            left: {
                type: Number
            },
            top: {
                type: Number
            },
            width: {
                type: Number
            },
            height: {
                type: Number
            },
            rotation: {
                type: Number
            }
        }
    })
], Resizer);
/* harmony default export */ __webpack_exports__["a"] = (Resizer);
;


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PREVENT_CLICK_PROP = 'PREVENT_CLICK';
var EVENT_BOUND = 'rr-event-bound';
var isBound = function (el) {
    return el.hasAttribute(EVENT_BOUND);
};
var markBound = function (el) {
    if (el && el.setAttribute) {
        el.setAttribute(EVENT_BOUND, 'DONE');
    }
    else {
        throw new Error('[markBound] element is required!');
    }
};
/* harmony default export */ __webpack_exports__["a"] = (function (element, options) {
    if (isBound(element)) {
        return;
    }
    else {
        markBound(element);
    }
    var isDragging = false;
    options = options || {};
    var minDistance = options.minDistance || 3;
    var preventClick = typeof options.preventClick === 'undefined' ? true : options.preventClick;
    var cancelBubble = typeof options.cancelBubble === 'undefined' ? true : options.cancelBubble;
    var dragState = {
        startLeft: null,
        startTop: null
    };
    var start = function (event) {
        if (options.start) {
            var result = options.start(event);
            isDragging = result !== false;
        }
        else {
            isDragging = true;
        }
    };
    var end = function (event) {
        dragState.startLeft = null;
        dragState.startTop = null;
        if (isDragging && options.end) {
            options.end(event);
        }
        isDragging = false;
    };
    var moveFn = function (event) {
        if (!isDragging) {
            var startLeft = dragState.startLeft, startTop = dragState.startTop;
            var deltaLeft = Math.abs(event.clientX - startLeft);
            var deltaTop = Math.abs(event.clientY - startTop);
            if (deltaLeft > minDistance || deltaTop > minDistance) {
                start(event);
            }
        }
        if (isDragging && options.drag) {
            options.drag(event);
        }
    };
    var upFn = function (event) {
        setTimeout(function () {
            if (preventClick && element.getAttribute(PREVENT_CLICK_PROP)) {
                element.removeAttribute(PREVENT_CLICK_PROP);
            }
        }, 0);
        document.removeEventListener('mousemove', moveFn);
        document.removeEventListener('mouseup', upFn);
        document.onselectstart = null;
        document.ondragstart = null;
        end(event);
    };
    element.addEventListener('click', function (event) {
        if (preventClick && element.getAttribute(PREVENT_CLICK_PROP)) {
            event.stopPropagation();
            element.removeAttribute(PREVENT_CLICK_PROP);
        }
    });
    element.addEventListener('mousedown', function (event) {
        if (isDragging)
            return;
        document.onselectstart = function () { return false; };
        document.ondragstart = function () { return false; };
        document.addEventListener('mousemove', moveFn);
        document.addEventListener('mouseup', upFn);
        if (cancelBubble) {
            event.stopPropagation();
        }
        if (preventClick) {
            element.setAttribute(PREVENT_CLICK_PROP, 'true');
        }
        if (minDistance > 0) {
            dragState.startLeft = event.clientX;
            dragState.startTop = event.clientY;
        }
        else {
            start(event);
        }
    });
});
;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var toRadians = function (degree) {
    return degree / 180.0 * Math.PI;
};
var unRotatePoint = function (rotation, point, center) {
    var left = point.left, top = point.top;
    var centerX = center.left;
    var centerY = center.top;
    var sinX = Math.sin(toRadians(rotation));
    var cosX = Math.cos(toRadians(rotation));
    return {
        left: centerX + (cosX * (left - centerX) + sinX * (top - centerY)),
        top: centerY + (-sinX * (left - centerX) + cosX * (top - centerY))
    };
};
var rotatePoint = function (rotation, point, center) {
    return unRotatePoint(-rotation, point, center);
};
var fromP1P3 = function (p1, p3) {
    var left = Math.min(p1.left, p3.left);
    var top = Math.min(p1.top, p3.top);
    var width = Math.abs(p1.left - p3.left);
    var height = Math.abs(p1.top - p3.top);
    return {
        left: left, top: top, width: width, height: height
    };
};
var fromP1P3WithRotation = function (p1, p3, rotation) {
    if (rotation === void 0) { rotation = 0; }
    var center = {
        left: (p1.left + p3.left) / 2,
        top: (p1.top + p3.top) / 2
    };
    return fromP1P3(unRotatePoint(rotation, p1, center), unRotatePoint(rotation, p3, center));
};
var fromP2P4 = function (p2, p4) {
    var width = Math.abs(p4.left - p2.left);
    var height = Math.abs(p4.top - p2.top);
    var left = Math.max(p2.left, p4.left) - width;
    var top = Math.min(p2.top, p4.top);
    return {
        left: left,
        top: top,
        width: width,
        height: height
    };
};
var fromP2P4WithRotation = function (p2, p4, rotation) {
    if (rotation === void 0) { rotation = 0; }
    var center = {
        left: (p2.left + p4.left) / 2,
        top: (p2.top + p4.top) / 2
    };
    return fromP2P4(unRotatePoint(rotation, p2, center), unRotatePoint(rotation, p4, center));
};
var fromC12C34WithRotation = function (c12, c34, rotation, width) {
    var center = {
        left: (c12.left + c34.left) / 2,
        top: (c12.top + c34.top) / 2
    };
    var origin12 = unRotatePoint(rotation, c12, center);
    var origin34 = unRotatePoint(rotation, c34, center);
    var height = Math.abs(origin12.top - origin34.top);
    return {
        left: Math.min(origin12.left, origin34.left) - width / 2,
        top: Math.min(origin12.top, origin34.top),
        width: width,
        height: height
    };
};
var fromC14C23WithRotation = function (c14, c23, rotation, height) {
    var center = {
        left: (c14.left + c23.left) / 2,
        top: (c14.top + c23.top) / 2
    };
    var origin12 = unRotatePoint(rotation, c14, center);
    var origin34 = unRotatePoint(rotation, c23, center);
    var width = Math.abs(origin12.left - origin34.left);
    return {
        left: Math.min(origin12.left, origin34.left),
        top: Math.min(origin12.top, origin34.top) - height / 2,
        width: width,
        height: height
    };
};
var TRANSFORM_MAP = {
    'n': { p1y: true },
    'w': { p1x: true },
    'e': { p3x: true },
    's': { p3y: true },
    'nw': { p1x: true, p1y: true },
    'ne': { p1y: true, p3x: true },
    'sw': { p3y: true, p1x: true },
    'se': { p3y: true, p3x: true }
};
var getDeltaOfVector = function (p1, p2, deltaX, deltaY) {
    var vector = {
        x: p1.left - p2.left,
        y: p1.top - p2.top
    };
    var vectorLength = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
    var unitVector = {
        x: vector.x / vectorLength,
        y: vector.y / vectorLength
    };
    var factor = deltaX * unitVector.x + deltaY * unitVector.y;
    return {
        left: factor * unitVector.x,
        top: factor * unitVector.y
    };
};
var Rectangle = (function () {
    function Rectangle(rect, rotation) {
        this.rotation = 0;
        this.rotation = rotation;
        if (rect) {
            var left = rect.left, top_1 = rect.top, width = rect.width, height = rect.height;
            this.left = left;
            this.top = top_1;
            this.width = width;
            this.height = height;
        }
    }
    Object.defineProperty(Rectangle.prototype, "center", {
        get: function () {
            var _a = this, left = _a.left, top = _a.top, width = _a.width, height = _a.height;
            return {
                left: left + width / 2,
                top: top + height / 2
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "rotated", {
        get: function () {
            return this.rotation !== undefined && this.rotation !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Rectangle.prototype.getPoint = function (type) {
        var _a = this, left = _a.left, top = _a.top, width = _a.width, height = _a.height;
        var result = {
            left: null,
            top: null
        };
        switch (type) {
            case 'nw':
            case 'ne':
            case 'n':
                result.top = top;
                break;
            case 'sw':
            case 's':
            case 'se':
                result.top = top + height;
                break;
            case 'w':
            case 'e':
                result.top = top + height / 2;
                break;
        }
        switch (type) {
            case 'nw':
            case 'sw':
            case 'w':
                result.left = left;
                break;
            case 'ne':
            case 'se':
            case 'e':
                result.left = left + width;
                break;
            case 'n':
            case 's':
                result.left = left + width / 2;
                break;
        }
        var rotation = this.rotation;
        if (rotation !== undefined && rotation !== 0) {
            var center = this.center;
            result = rotatePoint(rotation, result, center);
        }
        return result;
    };
    Rectangle.prototype.translate = function (deltaX, deltaY) {
        if (deltaX === void 0) { deltaX = 0; }
        if (deltaY === void 0) { deltaY = 0; }
        if (!this.rotated) {
            this.left += deltaX;
            this.top += deltaY;
        }
        else {
            var p1 = this.getPoint('nw');
            var p2 = this.getPoint('se');
            p1.left += deltaX;
            p1.top += deltaY;
            p2.left += deltaX;
            p2.top += deltaY;
            return fromP1P3WithRotation(p1, p2, this.rotation);
        }
    };
    Rectangle.prototype.reset = function (rect) {
        this.left = rect.left;
        this.top = rect.top;
        this.width = rect.width;
        this.height = rect.height;
    };
    Rectangle.prototype.dragPoint = function (type, deltaX, deltaY, startPoint) {
        if (deltaX === void 0) { deltaX = 0; }
        if (deltaY === void 0) { deltaY = 0; }
        var transformMap = TRANSFORM_MAP[type];
        var p1 = this.getPoint('nw');
        var p3 = this.getPoint('se');
        var rotated = this.rotated;
        var rotation = this.rotation;
        if (rotated) {
            if (type === 's' || type === 'n') {
                var c12 = this.getPoint('n');
                var c34 = this.getPoint('s');
                var delta = getDeltaOfVector(c12, c34, deltaX, deltaY);
                if (type === 's') {
                    c34.left += delta.left;
                    c34.top += delta.top;
                }
                else if (type === 'n') {
                    c12.left += delta.left;
                    c12.top += delta.top;
                }
                return fromC12C34WithRotation(c12, c34, rotation, this.width);
            }
            if (type === 'e' || type === 'w') {
                var c14 = this.getPoint('w');
                var c23 = this.getPoint('e');
                var delta = getDeltaOfVector(c14, c23, deltaX, deltaY);
                if (type === 'e') {
                    c23.left += delta.left;
                    c23.top += delta.top;
                }
                else if (type === 'w') {
                    c14.left += delta.left;
                    c14.top += delta.top;
                }
                return fromC14C23WithRotation(c14, c23, rotation, this.height);
            }
            if (type === 'ne' || type === 'sw') {
                var p2 = this.getPoint('ne');
                var p4 = this.getPoint('sw');
                if (type === 'ne') {
                    p2.left = startPoint.left + deltaX;
                    p2.top = startPoint.top + deltaY;
                }
                else if (type === 'sw') {
                    p4.left = startPoint.left + deltaX;
                    p4.top = startPoint.top + deltaY;
                }
                return fromP2P4WithRotation(p2, p4, rotation);
            }
        }
        if (transformMap.p1x) {
            p1.left = startPoint.left + deltaX;
        }
        if (transformMap.p3x) {
            p3.left = startPoint.left + deltaX;
        }
        if (transformMap.p1y) {
            p1.top = startPoint.top + deltaY;
        }
        if (transformMap.p3y) {
            p3.top = startPoint.top + deltaY;
        }
        return fromP1P3WithRotation(p1, p3, rotation);
    };
    return Rectangle;
}());
/* harmony default export */ __webpack_exports__["a"] = (Rectangle);
;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue___default.a }
});


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resizer_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resizer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resizer_vue__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Hello = (function (_super) {
    __extends(Hello, _super);
    function Hello() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.degree = 30;
        _this.left = 100;
        _this.top = 100;
        _this.width = 100;
        _this.height = 100;
        _this.handles = '';
        _this.draggable = true;
        _this.rotatable = true;
        _this.disabled = false;
        _this.active = true;
        return _this;
    }
    Hello.prototype.handleChange = function (state) {
        this.left = state.left;
        this.top = state.top;
        this.width = state.width;
        this.height = state.height;
        this.degree = state.rotation;
    };
    return Hello;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
Hello = __decorate([
    __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
        name: 'hello',
        components: {
            Resizer: __WEBPACK_IMPORTED_MODULE_2__components_Resizer_vue___default.a
        }
    })
], Hello);
/* harmony default export */ __webpack_exports__["a"] = (Hello);
;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(6)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(21),
  /* scopeId */
  "data-v-6e140ed1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rr-resizer",
    class: {
      'rr-resizer--active': !_vm.disabled && _vm.active
    },
    style: ({
      transform: 'rotateZ(' + _vm.state.rotation + 'deg)',
      left: _vm.state.left + 'px',
      top: _vm.state.top + 'px',
      width: _vm.state.width + 'px',
      height: _vm.state.height + 'px',
    })
  }, [(_vm.rotatable) ? _c('div', {
    ref: "rotateHandle",
    staticClass: "rr-rotatable-handle"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('n')) ? _c('div', {
    key: "ord-n",
    staticClass: "rr-resizable-handle rr-resizable-n"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('s')) ? _c('div', {
    key: "ord-s",
    staticClass: "rr-resizable-handle rr-resizable-s"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('e')) ? _c('div', {
    key: "ord-e",
    staticClass: "rr-resizable-handle rr-resizable-e"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('w')) ? _c('div', {
    key: "ord-w",
    staticClass: "rr-resizable-handle rr-resizable-w"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('nw')) ? _c('div', {
    key: "ord-nw",
    staticClass: "rr-resizable-handle rr-resizable-nw"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('ne')) ? _c('div', {
    key: "ord-ne",
    staticClass: "rr-resizable-handle rr-resizable-ne"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('se')) ? _c('div', {
    key: "ord-se",
    staticClass: "rr-resizable-handle rr-resizable-se"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('sw')) ? _c('div', {
    key: "ord-sw",
    staticClass: "rr-resizable-handle rr-resizable-sw"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rr-resizer-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playground columns col-gapless"
  }, [_c('div', {
    staticClass: "column col-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "form-header"
  }, [_vm._v("Options")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Rotatable")]), _vm._v(" "), _c('label', {
    staticClass: "form-checkbox col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rotatable),
      expression: "rotatable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rotatable) ? _vm._i(_vm.rotatable, null) > -1 : (_vm.rotatable)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.rotatable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.rotatable = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rotatable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rotatable = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Draggable")]), _vm._v(" "), _c('label', {
    staticClass: "form-checkbox col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draggable),
      expression: "draggable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.draggable) ? _vm._i(_vm.draggable, null) > -1 : (_vm.draggable)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.draggable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.draggable = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.draggable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.draggable = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('label', {
    staticClass: "form-checkbox col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.disabled) ? _vm._i(_vm.disabled, null) > -1 : (_vm.disabled)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.disabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.disabled = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.disabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.disabled = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('label', {
    staticClass: "form-checkbox col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.active),
      expression: "active"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.active) ? _vm._i(_vm.active, null) > -1 : (_vm.active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Handles")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handles),
      expression: "handles"
    }],
    staticClass: "form-select col-7",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.handles = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nw,ne,se,sw"
    }
  }, [_vm._v("Corners")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "e,w"
    }
  }, [_vm._v("Horizontal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "n,s"
    }
  }, [_vm._v("Vertical")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-header"
  }, [_vm._v("State")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Degree")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.degree),
      expression: "degree",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "Degree"
    },
    domProps: {
      "value": (_vm.degree)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.degree = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.left),
      expression: "left",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "Left"
    },
    domProps: {
      "value": (_vm.left)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.left = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Top")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.top),
      expression: "top",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "Top"
    },
    domProps: {
      "value": (_vm.top)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.top = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Width")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.width),
      expression: "width",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "Width"
    },
    domProps: {
      "value": (_vm.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.width = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label col-5",
    attrs: {
      "for": "input-example-1"
    }
  }, [_vm._v("Height")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.height),
      expression: "height",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "placeholder": "Height"
    },
    domProps: {
      "value": (_vm.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.height = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "playground-content column col-9 empty"
  }, [_c('resizer', {
    attrs: {
      "active": _vm.active,
      "rotatable": _vm.rotatable,
      "draggable": _vm.draggable,
      "disabled": _vm.disabled,
      "handles": _vm.handles,
      "rotation": _vm.degree,
      "left": _vm.left,
      "top": _vm.top,
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_vm._v("\n      Slot Content\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.7714f7e3208a27b5bb5d.js